import { render, staticRenderFns } from "./material-climbing-wall.vue?vue&type=template&id=16abdada&scoped=true&"
import script from "./material-climbing-wall.vue?vue&type=script&lang=js&"
export * from "./material-climbing-wall.vue?vue&type=script&lang=js&"
import style0 from "./material-climbing-wall.vue?vue&type=style&index=0&id=16abdada&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16abdada",
  null
  
)

export default component.exports